
import Vue from 'vue';
import BorderSelectCard from '@/components/BorderSelectCard.vue';
import { mapGetters, mapState } from 'vuex';
import { getHardwareHourlyPrice } from '@run-diffusion/shared';
import { RUNNITS_OWNER_SELECTION } from '@/views/Runnits/constants';
import HardwareOfferPriceInTokens from '@/components/HardwareOfferPriceInTokens.vue';

export default Vue.extend({
	name: 'HardwareOfferCard',
	props: {
		appOffer: { type: Object, required: true },
		hardwareOffer: { type: Object, required: true },
		selected: { type: Boolean, default: false },
		runnitsOwnerSelection: { type: String, default: null },
	},
	data () {
		return {
			RUNNITS_OWNER_SELECTION,
		};
	},
	computed: {
		...mapState([
			'team',
			'user',
			'runnitState',
		]),
		...mapGetters([
			'mobiusEnabled',
		]),
		showNoWaitTime (): boolean {
			if (!this.mobiusEnabled) return false;
			const byRegion = this.hardwareOffer && this.hardwareOffer.availabilityByRegion;
			return !!(byRegion && byRegion['MOB-1'] && byRegion['MOB-1'].noWaitTime);
		},
		currRunnitsOwnerSelection () {
			// Prefer prop if provided (for static cases), otherwise use Vuex state
			if (this.runnitsOwnerSelection) {
				return this.runnitsOwnerSelection;
			}
			return (this.runnitState && this.runnitState.runnitsOwnerSelection) || RUNNITS_OWNER_SELECTION.USER;
		},
		descriptionHtml () {
			return this._get(this.hardwareOffer.descriptionHtmlAppOverride, this.appOffer.app) || this.hardwareOffer.descriptionHtml;
		},
		hourlyPriceInCents (): number {
			if (!this.hardwareOffer) return 0;
			return getHardwareHourlyPrice(
				this.hardwareOffer,
				this.currRunnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM && this.team && this.team.isActive ? this.team.id : null,
				this.user?.club
			);
		},
	},
	components: {
		BorderSelectCard,
		HardwareOfferPriceInTokens,
	},
});
